import React from 'react';
import { FiBriefcase } from 'react-icons/fi';

// Texas Graduation Endorsement mapping
const ENDORSEMENT_MAP = {
  "Agriculture, Food, and Natural Resources": "Business and Industry",
  "Architecture and Construction": "Business and Industry",
  "Arts, Audio/Video Technology and Communications": "Business and Industry",
  "Business Management and Administration": "Business and Industry",
  "Education and Training": "Public Services",
  "Energy": "Business and Industry",
  "Finance": "Business and Industry",
  "Government and Public Administration": "Public Services",
  "Health Science": "Public Services",
  "Hospitality and Tourism": "Business and Industry",
  "Human Services": "Public Services",
  "Information Technology": "Business and Industry",
  "Law, Public Safety, and Corrections": "Public Services",
  "Manufacturing": "Business and Industry",
  "Marketing": "Business and Industry",
  "Science, Technology, Engineering, and Math": "STEM",
  "Transportation, Distribution, and Logistics": "Business and Industry"
};

const CareerClusters = ({ clusters }) => {
  // Handle undefined or empty clusters
  if (!clusters || clusters.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center mb-4">
          <FiBriefcase className="h-5 w-5 text-primary-600 mr-2" />
          <h2 className="text-xl font-semibold text-gray-900">Recommended Career Clusters</h2>
        </div>
        <p className="text-gray-500 italic">No career clusters selected</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center mb-4">
        <FiBriefcase className="h-5 w-5 text-primary-600 mr-2" />
        <h2 className="text-xl font-semibold text-gray-900">Recommended Career Clusters</h2>
      </div>

      <div className="space-y-3">
        {clusters.map((cluster, index) => {
          // Handle both object format {careerCluster: "..."} and string format
          const clusterName = typeof cluster === 'object' ? cluster.careerCluster : cluster;
          const endorsement = ENDORSEMENT_MAP[clusterName];

          return (
            <div
              key={index}
              className="border-2 border-primary-200 bg-primary-50 rounded-lg p-4"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-900 mb-1">
                    {clusterName}
                  </h3>
                  {endorsement && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-purple-100 text-purple-800 border border-purple-200">
                      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      Texas {endorsement} Endorsement
                    </span>
                  )}
                </div>
                <span className="inline-flex items-center justify-center w-8 h-8 bg-primary-600 text-white rounded-full text-sm font-bold ml-3">
                  {index + 1}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CareerClusters;
